import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import Breadcrumb from 'components/common/Breadcrumb';
import Description from './Parts/Description';
import Footer from './Parts/Footer';
import Chunk from './Chunks/Chunk';
import startCase from 'lodash/startCase';
import MyHelmet from 'components/common/MyHelmet';
import './Project.css';

class Project extends Component {
	getCover = (cover) => {
		if ( !cover ) return null;
		if ( typeof cover === 'string' ) {
			return <Chunk type="video" video={cover} />
		} else {
			const coverRatio = cover ? cover.width / cover.height : null;
			const coverChunkType = (coverRatio > 1)? 'single-l' : 'single-s';
			return <Chunk type={coverChunkType} images={[ {"image": cover} ]} />
		}
	}
	render() {
		const { status, slug, breadcrumb, year, client, cover, description, gallery, tags, related } = this.props;
		if ( status === 'success' ) {
			const galleries = (gallery)? gallery.map( (item, index) => {
				if ( item.type === 'single-vid-l' ) {
					const video_url = get( item.images[0], ['video', 'videoLink'], null );
					return <Chunk key={index} type='video' video={video_url} />
				} else {
					return <Chunk key={index} type={item.type} images={item.images}  />
				}
			} ) : null;
			const coverEl = this.getCover(cover);

			return (
				<div id="Page_Project" className="Page" key={slug}>
					<MyHelmet
						title={`${this.props.title} ${this.props.row2}`}
						description={description}
						image={typeof cover === 'object' ? cover : undefined}
					/>

					<div className="wrap">
						<Breadcrumb items={breadcrumb} />
					</div>

					<header className="Project-header">
						<div className="wrap">
							{ year && <span className="meta meta-year"><Link to={'/years/'+year.slug}>{year.title}</Link></span> }
							{ client && <span className="meta meta-client">{client.title}</span> }
						</div>
					</header>
						
					{cover && <div className="Project-cover">{ coverEl }</div> }
					
					<Description text={description} />

					<div className="Project-images">
						{galleries}
					</div>

					<Footer tags={tags} related={related} />
				</div>
			)
		} else {
			return (
				<div id="Page_Project" className="Page"></div>
			)
		}
	}
}
Project.propTypes = { 
	status: PropTypes.string,
	slug: PropTypes.string,
	title: PropTypes.string,
	row2: PropTypes.string,
	year: PropTypes.object,
	client: PropTypes.object,
	related: PropTypes.array,
	tags: PropTypes.array,
	description: PropTypes.string,
	cover: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.string,
	]),
	gallery: PropTypes.array,
	breadcrumb: PropTypes.array,
}
const mapStateToProps = (state, ownProps) => {
	const { slug } = ownProps.match.params;
	const result = get( state.fetcher, ['projects', slug], {} );
	const status = result.status || null;

	if (result && result.data) {
		const data = result.data;
		const fullTitle = data.title + ' ' + data.row2;
		const coverVideo = (data.coverUseVideo && data.coverVideoLink) ? data.coverVideoLink : null;
		return {
			status: status,
			slug: data.slug,
			title: data.title,
			row2: data.row2,
			year: data.year,
			client: data.client,
			related: data.relatedProjects,
			tags: data.tags,
			description: data.description,
			cover: coverVideo || data.coverImage,
			gallery: data.gallery,
			breadcrumb: (data.title)? [{title: fullTitle}] : [{title: startCase(slug) }]
		};
	} else {
		return {
			status: status,
		};
	}
}
export default connect(mapStateToProps)(Project);


// WEBPACK FOOTER //
// ./src/components/Pages/Project/Project.jsx